<template>
  <SettingsCard
    :title="$t('settings.language.title')"
    :subtitle="$t('settings.language.subtitle', { readablePlatformName })"
    :model-value="isOpen"
    @update:modelValue="setOpen"
  >
    <div class="pa-4">
      <v-row>
        <v-col
          cols="12"
          sm="6"
          class="px-0 px-md-2"
        >
          <div>
            <span class="font-weight-bold"> {{ $t('settings.language.body-texts.0') }}<br /> </span>
            <span class="text-grey">
              {{ $t('settings.language.body-texts.1', { readablePlatformName }) }}<br />
            </span>
            <span class="text-grey">
              {{ $t('settings.language.body-texts.2') }}
            </span>
            {{ ' ' }}
            <span
              class="text-primary"
              style="text-decoration: underline"
            >
              <router-link to="/settings/company?settings-open=language">{{
                $t('settings.language.body-texts.3')
              }}</router-link>
            </span>
            {{ ' ' }}
            <span class="text-grey">
              {{ $t('settings.language.body-texts.4') }}
            </span>
          </div>
        </v-col>
        <v-col
          cols="12"
          sm="6"
          class="px-0 px-md-2"
        >
          <LanguageSwitch />
        </v-col>
      </v-row>
    </div>
  </SettingsCard>
</template>

<script>
import LanguageSwitch from '@/components/LanguageSwitch.vue'
import SettingsCard from '@/components/SettingsCard.vue'
import { useQueryOpen } from '@/composables/useQueryOpen'
import branding from '@/mixins/branding'

export default {
  setup() {
    const { isOpen, setOpen } = useQueryOpen({ settingName: 'language' })
    return {
      isOpen,
      setOpen,
    }
  },
  components: { SettingsCard, LanguageSwitch },
  mixins: [branding],
}
</script>
